import httpClient from "./httpClient";

const CONTENT = "/content";
export const getContents = (params) => httpClient.get(CONTENT, { params });
export const saveContent = (payload = {}) =>
  httpClient.post(`${CONTENT}/schedule`, payload);
export const deleteContent = (id) => httpClient.delete(`${CONTENT}?id=${id}`);
export const sendMessage = (payload) =>
  httpClient.post(`${CONTENT}/messages`, payload);
